/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import CourseAccessType from './CourseAccessType';
import Document from './Document';
import DocumentType from './DocumentType';

/**
 * The StudentCourseAccess model module.
 * @module model/StudentCourseAccess
 * @version 1.0.0
 */
class StudentCourseAccess {
    /**
     * Constructs a new <code>StudentCourseAccess</code>.
     * @alias module:model/StudentCourseAccess
     * @param id {Number} 
     * @param studentId {Number} 
     * @param title {String} 
     * @param grade {Number} 
     * @param files {Array.<module:model/Document>} 
     */
    constructor(id, studentId, title, grade, files) { 
        
        StudentCourseAccess.initialize(this, id, studentId, title, grade, files);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, id, studentId, title, grade, files) { 
        obj['id'] = id;
        obj['student_id'] = studentId;
        obj['title'] = title;
        obj['grade'] = grade;
        obj['files'] = files;
    }

    /**
     * Constructs a <code>StudentCourseAccess</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/StudentCourseAccess} obj Optional instance to populate.
     * @return {module:model/StudentCourseAccess} The populated <code>StudentCourseAccess</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new StudentCourseAccess();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('student_id')) {
                obj['student_id'] = ApiClient.convertToType(data['student_id'], 'Number');
            }
            if (data.hasOwnProperty('block_id')) {
                obj['block_id'] = ApiClient.convertToType(data['block_id'], 'Number');
            }
            if (data.hasOwnProperty('title')) {
                obj['title'] = ApiClient.convertToType(data['title'], 'String');
            }
            if (data.hasOwnProperty('description')) {
                obj['description'] = ApiClient.convertToType(data['description'], 'String');
            }
            if (data.hasOwnProperty('grade')) {
                obj['grade'] = ApiClient.convertToType(data['grade'], 'Number');
            }
            if (data.hasOwnProperty('type')) {
                obj['type'] = CourseAccessType.constructFromObject(data['type']);
            }
            if (data.hasOwnProperty('document_type')) {
                obj['document_type'] = DocumentType.constructFromObject(data['document_type']);
            }
            if (data.hasOwnProperty('files')) {
                obj['files'] = ApiClient.convertToType(data['files'], [Document]);
            }
            if (data.hasOwnProperty('level')) {
                obj['level'] = ApiClient.convertToType(data['level'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * @member {Number} id
 */
StudentCourseAccess.prototype['id'] = undefined;

/**
 * @member {Number} student_id
 */
StudentCourseAccess.prototype['student_id'] = undefined;

/**
 * View block identifier
 * @member {Number} block_id
 */
StudentCourseAccess.prototype['block_id'] = undefined;

/**
 * @member {String} title
 */
StudentCourseAccess.prototype['title'] = undefined;

/**
 * @member {String} description
 */
StudentCourseAccess.prototype['description'] = undefined;

/**
 * @member {Number} grade
 */
StudentCourseAccess.prototype['grade'] = undefined;

/**
 * @member {module:model/CourseAccessType} type
 */
StudentCourseAccess.prototype['type'] = undefined;

/**
 * @member {module:model/DocumentType} document_type
 */
StudentCourseAccess.prototype['document_type'] = undefined;

/**
 * @member {Array.<module:model/Document>} files
 */
StudentCourseAccess.prototype['files'] = undefined;

/**
 * Level of the course
 * @member {Number} level
 */
StudentCourseAccess.prototype['level'] = undefined;






export default StudentCourseAccess;

